export default __webpack_public_path__ + "static/media/war_day_bg.b290b256.gif";